module.exports = __webpack_public_path__ + "static/img/bz.35c6989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hot-back/bz.png
// module id = +NIw
// module chunks = 1